import { type ReviewWindow } from "./helpers";

export const annualWheelEventColors = [
  "blue",
  "purple",
  "pink",
  "red",
  "yellow",
] as const;
export type AnnualWheelEventColor = (typeof annualWheelEventColors)[number];

export type ReviewStatus = "notStarted" | "inProgress" | "published";

export interface AnnualWheelWorkflowStep {
  name: string;
  dueAt: string;
  completedAt: string | null;
}

// One release of a document and the review it went through
export interface AnnualWheelRelease {
  id: number;
  majorVersion: number;
  reviewFrom: string | null;
  reviewTo: string | null;
  status: ReviewStatus;
  workflowSteps: AnnualWheelWorkflowStep[];
}

export interface AnnualWheelEntry {
  id: number;
  name: string;
  latestRelease: AnnualWheelRelease;
  // Newest first
  previousReleases: AnnualWheelRelease[];
}

// A day worth marking, such as a board meeting
export interface AnnualWheelEvent {
  id: number;
  name: string;
  // A calendar day, YYYY-MM-DD
  date: string;
  color: AnnualWheelEventColor;
}

export type AnnualWheelEventData = Omit<AnnualWheelEvent, "id">;

// The two views are the two tabs of the page
export const annualWheelTabs = ["wheel", "line"] as const;

export type AnnualWheelTab = (typeof annualWheelTabs)[number];

export interface ReviewWindowsChartProps {
  today: Date;
  reviewWindows: ReviewWindow[];
  // Stays set while zooming back out, so its documents can animate away
  openedWindow?: ReviewWindow;
  // 0 shows every review window, 1 only the opened one
  zoom: number;
  onOpen: (reviewWindow: ReviewWindow) => void;
  events: AnnualWheelEvent[];
  // The event whose pin stands out because something outside the chart points at it
  highlightedEventId?: number;
  onEventOpen: (annualWheelEvent: AnnualWheelEvent) => void;
}
